export default "__VITE_ASSET__DGXuNHgA__"